module.exports = __webpack_public_path__ + "nicon_show_hide.svg";